import * as tracking from 'dibs-tracking';
import { getAbTestTrackingData } from 'dibs-buyer-layout/exports/clientABTestHelpers';

/**
 * Uncomment following block when new CDN test is running and it requires additional tracking.
 */

/*
import serverVars from 'server-vars';

const getCdnTestData = ({ queryParam, serverVarName }) => {
    const cdnQueryParams = serverVars.get('cdnQueryParams') || {};

    return {
        // If cdn query param exists - test is running.
        isRunning: !!cdnQueryParams[queryParam],
        // If server var and cdn query param is set to "true" - it's test variant.
        isTestVariant: serverVars.get(serverVarName) && cdnQueryParams[queryParam] === 'true',
    };
};
*/

export const cdnTestTracking = () => {
    let additional = {}; // eslint-disable-line prefer-const

    /**
     * CDN tests additional tracking goes here.
     */

    return additional;
};

export const cdnTestEcommerceTracking = () => {
    let variants = {}; // eslint-disable-line prefer-const

    /**
     * CDN tests additional ecommerce tracking goes here.
     */

    return variants;
};

export const trackRerankEngagementScoreTest = ({ isSearch, hasCategories, pageContext }) => {
    if (isSearch && hasCategories) {
        const trackingData = getAbTestTrackingData(document.cookie, 'RERANK_ENGAGEMENT_SCORE_TEST');
        tracking.trackAbTestEvent(trackingData, pageContext);
    }
};
